/**
 * WordPress dependencies
 */

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { default as InspectorInterface } from '../../../interface/Inspector/index.js';
import blockInfo from './constants';
const { hookPrefix } = blockInfo;

import './inspector/tabs';

const Inspector = ( props ) => {
	return <InspectorInterface hookPrefix={ hookPrefix } { ...props } />;
};

export default Inspector;
